/**
 * Myma Design System - Color Palette
 * 
 * This file contains the color system for the Myma desktop application.
 * Use these color variables throughout the application for consistency.
 */

// Primary brand colors
export const primary = {
  main: '#28193e',    // Primary purple (sidebar, header)
  light: '#3d2a57',   // Lighter purple
  dark: '#1a102c',    // Darker purple
  contrast: '#ffffff' // Text on primary
};

// Secondary brand color
export const secondary = {
  main: '#EA572E',    // Orange accent color
  light: '#f7855b',   // Lighter orange
  dark: '#c73e1d',    // Darker orange
  contrast: '#ffffff' // Text on secondary
};

// Background colors
export const background = {
  default: '#f8f9fa',  // Main background (warm off-white)
  paper: '#ffffff',    // Card background (pure white)
  tabs: '#f2f0ed',     // Tab header (warm grey/beige)
  sidebar: '#28193e',  // Sidebar background
};

// Text colors
export const text = {
  primary: '#222222',   // Primary text
  secondary: '#666666', // Secondary text
  disabled: '#999999',  // Disabled text
  hint: '#888888',      // Hint text
  contrast: '#ffffff'   // Text on dark backgrounds
};

// Alert/Status colors
export const status = {
  success: '#8dc572', // Success green
  error: '#be6464',   // Error red
  warning: '#f0ad4e', // Warning yellow/orange
  info: '#337ab7'     // Info blue
};

// Border, shadow, and UI element colors
export const ui = {
  divider: 'rgba(0, 0, 0, 0.08)',   // Divider lines
  border: 'rgba(0, 0, 0, 0.08)',    // Borders
  shadow: 'rgba(0, 0, 0, 0.05)',    // Shadows
  hover: 'rgba(0, 0, 0, 0.04)',     // Hover state
  selected: 'rgba(255, 255, 255, 0.08)', // Selected item (on dark bg)
  focus: 'rgba(40, 25, 62, 0.2)'    // Focus state
};

// Semantic/Chart colors for data visualization
export const chart = {
  blue: '#5b8ef2',
  green: '#69c070',
  orange: '#f5a742',
  purple: '#8b66c2',
  red: '#e35d5d',
  teal: '#5cbcb8',
  yellow: '#f0ad4e'
};

// Promotion-specific colors for mobile UI
export const promotion = {
  combo: '#ff6b6b',          // Fiery red for combo promotions
  discount: '#4ecdc4',       // Cool teal for discount promotions
  gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  cardBg: 'rgba(255, 255, 255, 0.95)',
  success: '#51cf66',        // For copy success states
  overlay: 'rgba(0, 0, 0, 0.7)', // For mobile overlays
  shadow: 'rgba(0, 0, 0, 0.1)'   // Card shadows
};

// Sidebar specific colors
export const sidebarSelectedBg = 'rgba(255, 255, 255, 0.9)';
export const sidebarHoverBg = 'rgba(255, 255, 255, 0.04)';
export const sidebarText = '#fff';

// Export all categories together
const colors = {
  primary,
  secondary,
  background,
  text,
  status,
  ui,
  chart,
  promotion,
  sidebarSelectedBg,
  sidebarHoverBg,
  sidebarText
};

export default colors;